<template>
  <div>
    <div class="row mb-2">
      <div class="col-12 col-md-6 col-lg-6 col-xl-6">
        <h1 class="modal-h1 mb-3">
          <button type="button" class="btn btn-back" @click="$emit('cancel')" />
          <span v-if="type === 'claim'">
            Refund Claim
          </span>
          <span v-else>
            New Transaction
          </span>
        </h1>
      </div>
      <div class="col-12 col-md-6 col-lg-6 col-xl-6">
        <h5 class="pull-right" v-if="type === 'claim'">
          <small>Settlement amount:</small>
          <small class="text-danger">${{ claim.settlement_amount }}</small>
        </h5>
        <div class="d-flex flex-column remaining-price" v-else>
          <div v-if="job.company.cash_discount_value > 0">
            <h5>
              <small>Remaining for credit card or split:</small>
              <small class="text-danger">${{ job.remaining_price }}</small>
            </h5>
            <h5>
              <small>Remaining for cash:</small>
              <small class="text-danger">${{ job.remaining_cash_price }}</small>
            </h5>
          </div>
          <div v-else>
            <h5 class="pull-right">
              <small>Balance due:</small>
              <small class="text-danger">${{ job.remaining_price }}</small>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="row mb-1 mb-md-2 mb-lg-2 mb-xl-2">
        <div class="col-12 col-md-6 col-lg-6 col-xl-6 pr-3 pr-md-0 pr-lg-0 pr-xl-0" v-if="type === 'job'">
          <div class="select-wrap">
            <label>Payment type:</label>
            <simple-select v-model="transaction.payment_type_id"
                           :options="paymentTypes"
                           placeholder="Select Type"
                           @input="errors.clear('payment_type_id')"
            />
          </div>
          <error-field :errors="errors" field="payment_type_id" />
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-6 pr-3 pr-md-0 pr-lg-0 pr-xl-0" v-else>
          <div class="select-wrap">
            <label>Payment type:</label>
            <simple-select v-model="transaction.payment_type_id"
                           :options="refundType"
                           placeholder="Select Type"
                           @input="errors.clear('payment_type_id')"
            />
          </div>
          <error-field :errors="errors" field="payment_type_id" />
        </div>
        <div class="col-12 col-md-6 col-lg-6 col-xl-6 pl-3 pl-md-1 pl-lg-1 pl-xl-1">
          <div class="select-wrap">
            <label>Payment method:</label>
            <simple-select v-model="transaction.payment_method_id"
                           :options="paymentMethods"
                           placeholder="Select Method"
                           @input="errors.clear('payment_method_id')"
            />
          </div>
          <error-field :errors="errors" field="payment_method_id" />
        </div>
      </div>

      <template v-if="transaction.payment_type_id === 2 && transaction.payment_method_id === 4">
        <template v-if="job.charges">
          <div>
            <span>
              Select a transaction you wish to refund:
            </span>
            <div
              class="mt-2"
              v-for="(charge, index) in jobCharges.filter(el => el.payment_type_id === 1 || el.payment_type_id === 3)"
              :key="`trans-s-${index}`"
            >
              <div class="row mb-2">
                <div class="col-2 text-right pt-2 pl-0 cc-n-umber radio-button-wrap">
                  <label :for="'t' + index" class="pointer w-100 h-100">
                    <input type="radio" name="charge_id"
                           v-model="transaction.charge_id"
                           :value="charge.id"
                           :id="'t' + index"
                           @input="errors.clear('charge_id')"
                    />
                    <span class="btn-radio" />
                  </label>
                </div>
                <div class="col-3 charge-amount">
                  $ {{ charge.amount }}
                </div>
                <h5 class="col-3 d-inline">{{ charge.payment_type.name }}</h5>
                <div class="col-4">
                  (**** {{ charge.card.last4 }})
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="row mb-2">
          <div class="col-12">
            <span class="text-danger">No refundable transactions</span>
          </div>
        </div>
        <error-field :errors="errors" field="charge_id" />
      </template>
      <template v-else-if="transaction.payment_type_id === 4 && transaction.payment_method_id === 4">
        <template v-if="job.charges">
          <div>
            <span>
              Select a transaction you wish to refund:
            </span>
            <div
              class="mt-2"
              v-for="(charge, index) in jobCharges.filter(el => el.payment_type_id === 1 || el.payment_type_id === 3)"
              :key="`trans-s-${index}`"
            >
              <div class="row mb-2 card-info-wrap">
                <div class="col-2 text-right pt-2 pl-0 cc-n-umber radio-button-wrap">
                  <label :for="'t' + index" class="pointer w-100 h-100">
                    <input type="radio" name="charge_id"
                           v-model="transaction.charge_id"
                           :value="charge.id"
                           :id="'t' + index"
                           @input="errors.clear('charge_id')"
                    />
                    <span class="btn-radio" />
                  </label>
                </div>
                <div class="col-3 charge-amount">
                  $ {{ charge.amount }}
                </div>
                <h5 class="col-3 d-inline">{{ charge.payment_type.name }}</h5>
                <div class="col-4">
                  (**** {{ charge.card.last4 }})
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="row mb-2">
          <div class="col-12">
            <span class="text-danger">No refundable transactions</span>
          </div>
        </div>
        <error-field :errors="errors" field="charge_id" />
      </template>
      <template v-else-if="transaction.payment_method_id === 4 && job">
        <payment :customer="job.customer" :company="job.company" :transaction="transaction" width="col-12"
                 v-if="transaction.payment_method_id === 4"
                 @update="$emit('update')"
        />
      </template>

      <div class="row mb-2">
        <div class="col-12 col-md-6 col-lg-6 col-xl-6 pr-3 pr-md-0 pr-lg-0 pr-xl-0">
          <div class="select-wrap">
            <label>Price:</label>
            <input type="text" class="form-control" v-model="transaction.amount"
                   @keydown="errors.clear('amount')"
            />
          </div>
          <error-field :errors="errors" field="amount" />
        </div>
        <div class="col-6 pl-1 transactions-overcharge">
          <span class="pl-2" v-if="transaction.payment_type_id === 4 && transaction.payment_method_id === 4 && transaction.amount > 0">
            {{ job.company.charge_fee }}% is automatically added on the entered amount. Total for refund is ${{ formatOverchargeAmount(transaction.amount, job.company.charge_fee) }}.
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="select-wrap h-auto">
            <label>Notes:</label>
            <textarea class="select-wrap-textarea form-control" rows="5" v-model="transaction.note" />
          </div>
          <error-field :errors="errors" field="note" />
          <error-field :errors="errors" field="ref_id" />
        </div>
      </div>
    </div>
    <div class="row w-100 job-buttons position-absolute">
      <div class="col-12 py-2 border-top text-right">
        <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
          Cancel
        </button>
        <button type="button" class="btn btn-primary ld-ext-right"
                :class="loadingButton ? 'running' : ''"
                :disabled="buttonDisabled"
                @click="createTransaction"
        >
          Save
          <div class="ld ld-ball ld-flip" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Payment from '../Payment';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';

export default {
  components: {
    ErrorField,
    Payment,
  },
  props: {
    claim: {
      type: Object,
      default: () => {},
    },
    job: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    transaction: {},
    paymentTypes: [],
    paymentMethods: [],
    refundType: [],
    errors: new Errors(),
    loadingButton: false,
    buttonDisabled: false,
    type: 'job',
    queryParameter: '',
  }),
  computed: {
    jobCharges() {
      return this.job.charges.filter(el => el.payment_method_id === 4 && el.payment_type_id !== 2);
    },
    claimJobCharges() {
      return this.claim.job.charges.filter(
        el => el.payment_method_id === 4 && el.payment_type_id !== 2,
      );
    },
  },
  created() {
    if (this.claim) {
      this.queryParameter = `claim_id=${this.claim.id}`;
      this.type = 'claim';
      this.job = this.claim.job;
    } else {
      this.queryParameter = `job_id=${this.job.id}`;
    }
    this.getPaymentTypes();
    this.getPaymentMethods();
  },
  methods: {
    createTransaction() {
      this.buttonDisabled = true;
      this.loadingButton = true;
      if (this.type === 'claim') {
        axios
          .post(`charges`, {
            ...this.transaction,
            ref_id: this.claim.job.ref_id,
            claim_id: this.claim ? this.claim.id : null,
          })
          .then(() => {
            toastr.success('Refund successfully issued');
            this.transaction = {};
            this.$emit('update');
            this.$emit('cancel');
          })
          .catch(err => {
            if (err.response.data.error.charge) {
              toastr.error(err.response.data.error.charge);
            }
            this.errors.record(err.response.data.error);
          })
          .finally(() => {
            this.loadingButton = false;
            this.buttonDisabled = false;
          });
      } else {
        axios
          .post(`charges`, { ...this.transaction, ref_id: this.job.ref_id })
          .then(() => {
            toastr.success('New transaction successfully saved');
            this.transaction = {};
            this.$emit('update');
            this.$emit('cancel');
          })
          .catch(err => {
            if (err.response.data.error.charge) {
              toastr.error(err.response.data.error.charge);
            }
            this.errors.record(err.response.data.error);
          })
          .finally(() => {
            this.loadingButton = false;
            this.buttonDisabled = false;
          });
      }
    },
    formatOverchargeAmount(amount, chargeFee) {
      return parseInt(amount, 10) + (parseInt(amount, 10) / 100) * parseInt(chargeFee, 10);
    },
    getPaymentTypes() {
      axios.get(`values/payment-types?${this.queryParameter}`).then(res => {
        this.paymentTypes = res.data.data;
        this.paymentTypes.filter(
          type => (type.name === 'Refund' ? this.refundType.push(type) : ''),
        );
      });
    },
    getPaymentMethods() {
      axios.get(`values/payment-methods?${this.queryParameter}`).then(res => {
        this.paymentMethods = res.data.data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.remaining-price {
  text-align: end;
}
.transactions-overcharge {
  font-size: 10px;
  display: flex;
  align-items: center;
}
.btn-radio {
  left: 19px !important;
}
.charge-amount {
  line-height: 2.3;
}
</style>



// WEBPACK FOOTER //
// src/components/transactions/TransactionsModal.vue